import React from 'react';
import { Network, Shield, Code, Headphones, Server, Settings, Video, Brain } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';

const Services = () => {
  const iconMap = {
    Network: Network,
    Shield: Shield,
    Code: Code,
    Headphones: Headphones,
    Server: Server,
    Settings: Settings,
    Video: Video,
    Brain: Brain
  };

  const services = [
    {
      id: 1,
      icon: 'Network',
      title: 'Redes de Datos y WiFi',
      description: 'Diseño, implementación y optimización de infraestructuras de red cableadas e inalámbricas de alto rendimiento para empresas.'
    },
    {
      id: 2,
      icon: 'Shield',
      title: 'Seguridad Tecnológica',
      description: 'Soluciones integrales de ciberseguridad, protección de datos, sistemas de respaldo y videovigilancia empresarial.'
    },
    {
      id: 3,
      icon: 'Code',
      title: 'Desarrollo de Software',
      description: 'Creación de aplicaciones y sistemas personalizados que se adaptan a las necesidades específicas de tu negocio.'
    },
    {
      id: 4,
      icon: 'Headphones',
      title: 'Soporte Tecnológico',
      description: 'Asistencia técnica integral, mantenimiento preventivo y correctivo para garantizar la continuidad operativa de tu empresa.'
    },
    {
      id: 5,
      icon: 'Server',
      title: 'Venta de Equipos',
      description: 'Comercialización de equipos informáticos, servidores, networking y tecnología de última generación con garantía y soporte.'
    },
    {
      id: 6,
      icon: 'Settings',
      title: 'Consultoría IT',
      description: 'Asesoramiento estratégico en tecnología para optimizar recursos, mejorar procesos y impulsar la transformación digital.'
    },
    {
      id: 7,
      icon: 'Video',
      title: 'CCTV',
      description: 'Sistemas de videovigilancia profesional con tecnología IP, análisis inteligente y monitoreo remoto 24/7 para máxima seguridad.'
    },
    {
      id: 8,
      icon: 'Brain',
      title: 'Implementación de IA',
      description: 'Soluciones de inteligencia artificial personalizadas según tus requerimientos: automatización, análisis predictivo y optimización de procesos.'
    }
  ];

  return (
    <section id="services" className="py-20 md:py-32 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Nuestros <span className="text-red-600">Servicios</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Soluciones tecnológicas completas diseñadas para potenciar el crecimiento y la eficiencia de tu empresa
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="border-2 border-gray-100 hover:border-red-600 transition-all duration-300 hover:shadow-xl group"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-red-50 rounded-lg flex items-center justify-center mb-4 group-hover:bg-red-600 transition-colors duration-300">
                    <IconComponent className="text-red-600 group-hover:text-white transition-colors duration-300" size={28} />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 mb-2">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
